var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpouseRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "spouseRegular-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 35,
    transform: "translate(-32.992 -1)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "spouseRegular",
    transform: "translate(32.992 1)",
    clipPath: "url(#spouseRegular-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.173,31.888h-.927V2.781a.556.556,0,0,0-.556-.556H18.308a.556.556,0,0,0-.556.556v2.41H16.639V2.781a.556.556,0,0,0-.556-.556h-2.41V.556a.556.556,0,1,0-1.112,0V2.225H10.15a.556.556,0,0,0-.556.556v2.41H7.926a.556.556,0,0,0-.556.556v4.635H2.735a.556.556,0,0,0-.556.556v20.95H1.251a.556.556,0,0,0,0,1.112H30.173a.556.556,0,0,0,0-1.112ZM10.707,3.337h4.82V5.191h-4.82ZM8.853,31.888H8.482v-.927a.556.556,0,1,0-1.112,0v.927H7V30.034H8.853Zm3.708-14.275V31.888h-2.6v-2.41a.556.556,0,0,0-.556-.556H6.443a.556.556,0,0,0-.556.556v2.41h-2.6V11.494h9.27Zm.556-7.23H8.482V6.3h9.27V17.056H13.673V15.2h1.669a.556.556,0,1,0,0-1.112H13.673V12.236h1.669a.556.556,0,1,0,0-1.112H13.673v-.185A.556.556,0,0,0,13.117,10.382Zm9.826,21.506h-9.27V18.169h9.27Zm5.191,0H24.055V16.871a.556.556,0,0,0-1.112,0v.185H21.83v-.185a.556.556,0,0,0-1.112,0v.185H18.864V3.337h9.27V31.888Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.218,46.551a.556.556,0,0,0,.556-.556V35.613a.556.556,0,1,0-1.112,0V45.995A.556.556,0,0,0,28.218,46.551Z",
    transform: "translate(-12.135 -15.775)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.263,46.551a.556.556,0,0,0,.556-.556V35.613a.556.556,0,1,0-1.112,0V45.995A.556.556,0,0,0,32.263,46.551Z",
    transform: "translate(-13.955 -15.775)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.308,46.551a.556.556,0,0,0,.556-.556V35.613a.556.556,0,1,0-1.112,0V45.995A.556.556,0,0,0,36.308,46.551Z",
    transform: "translate(-15.775 -15.775)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.656,11.292a.556.556,0,0,0,.556-.556V9.994a.556.556,0,0,0-1.112,0v.742A.556.556,0,0,0,37.656,11.292Z",
    transform: "translate(-16.382 -4.247)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7,11.292a.556.556,0,0,0,.556-.556V9.994a.556.556,0,0,0-1.112,0v.742A.556.556,0,0,0,41.7,11.292Z",
    transform: "translate(-18.202 -4.247)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.746,11.292a.556.556,0,0,0,.556-.556V9.994a.556.556,0,0,0-1.112,0v.742A.556.556,0,0,0,45.746,11.292Z",
    transform: "translate(-20.022 -4.247)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.656,18.034a.556.556,0,0,0,.556-.556v-.742a.556.556,0,1,0-1.112,0v.742A.556.556,0,0,0,37.656,18.034Z",
    transform: "translate(-16.382 -7.281)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7,18.034a.556.556,0,0,0,.556-.556v-.742a.556.556,0,0,0-1.112,0v.742A.556.556,0,0,0,41.7,18.034Z",
    transform: "translate(-18.202 -7.281)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.746,18.034a.556.556,0,0,0,.556-.556v-.742a.556.556,0,0,0-1.112,0v.742A.556.556,0,0,0,45.746,18.034Z",
    transform: "translate(-20.022 -7.281)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.656,24.775a.556.556,0,0,0,.556-.556v-.742a.556.556,0,0,0-1.112,0v.742A.556.556,0,0,0,37.656,24.775Z",
    transform: "translate(-16.382 -10.315)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7,24.775a.556.556,0,0,0,.556-.556v-.742a.556.556,0,0,0-1.112,0v.742A.556.556,0,0,0,41.7,24.775Z",
    transform: "translate(-18.202 -10.315)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.746,24.775a.556.556,0,0,0,.556-.556v-.742a.556.556,0,0,0-1.112,0v.742A.556.556,0,0,0,45.746,24.775Z",
    transform: "translate(-20.022 -10.315)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.341,27.472a.556.556,0,0,0,.556-.556v-.742a.556.556,0,0,0-1.112,0v.742A.556.556,0,0,0,9.341,27.472Z",
    transform: "translate(-3.64 -11.528)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.386,27.472a.556.556,0,0,0,.556-.556v-.742a.556.556,0,0,0-1.112,0v.742A.556.556,0,0,0,13.386,27.472Z",
    transform: "translate(-5.46 -11.528)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.431,27.472a.556.556,0,0,0,.556-.556v-.742a.556.556,0,0,0-1.112,0v.742A.556.556,0,0,0,17.431,27.472Z",
    transform: "translate(-7.281 -11.528)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.341,34.214a.556.556,0,0,0,.556-.556v-.742a.556.556,0,0,0-1.112,0v.742A.556.556,0,0,0,9.341,34.214Z",
    transform: "translate(-3.64 -14.562)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.386,34.214a.556.556,0,0,0,.556-.556v-.742a.556.556,0,1,0-1.112,0v.742A.556.556,0,0,0,13.386,34.214Z",
    transform: "translate(-5.46 -14.562)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.431,34.214a.556.556,0,0,0,.556-.556v-.742a.556.556,0,1,0-1.112,0v.742A.556.556,0,0,0,17.431,34.214Z",
    transform: "translate(-7.281 -14.562)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.341,40.955A.556.556,0,0,0,9.9,40.4v-.742a.556.556,0,0,0-1.112,0V40.4A.556.556,0,0,0,9.341,40.955Z",
    transform: "translate(-3.64 -17.595)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.386,40.955a.556.556,0,0,0,.556-.556v-.742a.556.556,0,0,0-1.112,0V40.4A.556.556,0,0,0,13.386,40.955Z",
    transform: "translate(-5.46 -17.595)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.431,40.955a.556.556,0,0,0,.556-.556v-.742a.556.556,0,0,0-1.112,0V40.4A.556.556,0,0,0,17.431,40.955Z",
    transform: "translate(-7.281 -17.595)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.341,47.7a.556.556,0,0,0,.556-.556V46.4a.556.556,0,0,0-1.112,0v.742A.556.556,0,0,0,9.341,47.7Z",
    transform: "translate(-3.64 -20.629)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.386,47.7a.556.556,0,0,0,.556-.556V46.4a.556.556,0,0,0-1.112,0v.742A.556.556,0,0,0,13.386,47.7Z",
    transform: "translate(-5.46 -20.629)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.431,47.7a.556.556,0,0,0,.556-.556V46.4a.556.556,0,0,0-1.112,0v.742A.556.556,0,0,0,17.431,47.7Z",
    transform: "translate(-7.281 -20.629)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.746,31.517a.556.556,0,0,0,.556-.556v-.742a.556.556,0,1,0-1.112,0v.742A.556.556,0,0,0,45.746,31.517Z",
    transform: "translate(-20.022 -13.348)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.746,38.258A.556.556,0,0,0,46.3,37.7v-.742a.556.556,0,1,0-1.112,0V37.7A.556.556,0,0,0,45.746,38.258Z",
    transform: "translate(-20.022 -16.382)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.746,45a.556.556,0,0,0,.556-.556V43.7a.556.556,0,1,0-1.112,0v.742A.556.556,0,0,0,45.746,45Z",
    transform: "translate(-20.022 -19.416)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.746,51.742a.556.556,0,0,0,.556-.556v-.742a.556.556,0,0,0-1.112,0v.742A.556.556,0,0,0,45.746,51.742Z",
    transform: "translate(-20.022 -22.449)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.786,15.388a.556.556,0,0,0-.556-.556h-4.45a.556.556,0,0,0,0,1.112h4.45A.556.556,0,0,0,23.786,15.388Z",
    transform: "translate(-7.888 -6.674)",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpouseRegular);
export default __webpack_public_path__ + "static/media/spouseRegular.ab9e622ed57a572e7b80f9377fe308be.svg";
export { ForwardRef as ReactComponent };